import { StrictMode } from "react";
import { hydrateRoot, createRoot } from "react-dom/client";
import { I18nProvider } from "./i18n/I18nProvider";
import { localeFromPath } from "./i18n/paths";
import { clarityTag } from "./lib/clarity";
import { readSource } from "./lib/utm";
import { LandingPage } from "./pages/LandingPage";
import { ThankYouPage } from "./pages/ThankYouPage";
import "./styles/index.css";
import "@fontsource-variable/cairo";
import "@fontsource/inter/400.css";
import "@fontsource/inter/600.css";

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("root element missing");

const pathname = window.location.pathname;
const locale = localeFromPath(pathname);
const isThankYou = pathname.endsWith("/thank-you");

clarityTag("locale", locale);
clarityTag("utm_source", readSource().utm_source);

const tree = (
  <StrictMode>
    <I18nProvider locale={locale}>{isThankYou ? <ThankYouPage /> : <LandingPage />}</I18nProvider>
  </StrictMode>
);

if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, tree);
} else {
  createRoot(rootElement).render(tree);
}
